import { render, staticRenderFns } from "./comNewsDetails.vue?vue&type=template&id=96a43748&"
import script from "./comNewsDetails.vue?vue&type=script&lang=js&"
export * from "./comNewsDetails.vue?vue&type=script&lang=js&"
import style0 from "./comNewsDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports